import { get } from '@/api/client';
import type { RcmSessionResponse } from './types';

const BASE = '/api/rcm/v1';

export const sessionApi = {
  /**
   * Who the RCM backend thinks you are. The first call after sign-in, and the
   * one that proves the whole chain: the account app's token reaches RCM, RCM
   * verifies it, resolves the practice from the token's location, and answers
   * with the permissions that token really carries.
   */
  me: () => get<RcmSessionResponse>(`${BASE}/me`),
};
